import { closeChecklistURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { getName } from 'utils/users/config';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import {
  TaskStatusReadyForReviewNotification,
  TaskStatusInPreparationNotification,
} from 'types/inbox-notifications/close/ChecklistNotifications';
import { SegmentAtByDot } from 'types/utils';

export type TaskStatusNotification =
  | TaskStatusReadyForReviewNotification
  | TaskStatusInPreparationNotification;

type TaskStatusLevelKeys = SegmentAtByDot<TaskStatusNotification['type'], 4>;

export function StatusNotificationItem({
  type,
  item,
}: {
  type: string[];
  item: TaskStatusNotification;
}) {
  const [actionType, ..._restOfType] = type;
  if (!item.task) {
    return <div>Notification task not found</div>;
  }

  switch (actionType as TaskStatusLevelKeys) {
    case 'ready_for_review':
      return (
        <ReadyForReviewNotificationItem
          item={item as TaskStatusReadyForReviewNotification}
        />
      );
    case 'in_preparation':
      return (
        <InPreparationNotificationItem
          item={item as TaskStatusInPreparationNotification}
        />
      );
    default:
      return <div>Unknown task status notification type: {actionType}</div>;
  }
}

function ReadyForReviewNotificationItem({
  item,
}: {
  item: TaskStatusReadyForReviewNotification;
}) {
  return (
    <GenericNotificationItem
      item={item}
      url={closeChecklistURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`Your task is ready for review.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}

function InPreparationNotificationItem({
  item,
}: {
  item: TaskStatusInPreparationNotification;
}) {
  const { usersMap } = useUsersData();
  const actorName = getName(item.actor_id, usersMap);
  return (
    <GenericNotificationItem
      item={item}
      url={closeChecklistURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`${actorName} requested more preparation.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}
